import { UseQueryOptions, useQuery } from '@tanstack/react-query';

import { WalletProviderInterface } from 'app/types/providers';

import { CosmosChainId } from 'chains/cosmos/cosmos.types';

import { useAuthentication } from '../useAuthentication';

export const signingStargateClientQuery = (
  chainId: CosmosChainId,
  provider: WalletProviderInterface,
) =>
  ({
    queryKey: [
      'signingStargateClient',
      chainId,
      provider?.elysAddress ?? null,
      provider?.type ?? null,
      provider?.walletType ?? null,
    ],
    queryFn: () => provider?.createSigningStargateClient(chainId),
    refetchOnWindowFocus: false,
    //@ts-expect-error suspense is not included in UseQueryOptions type
    suspense: true,
    staleTime: Infinity,
  }) satisfies UseQueryOptions;

export const useSigningStargateClient = (chainId: CosmosChainId) => {
  const {provider, connected} = useAuthentication();

  const {
    data: client,
    isLoading,
    isError,
    error,
  } = useQuery({
    ...signingStargateClientQuery(chainId, provider),
    enabled: connected,
  });

  return {
    client,
    isLoading,
    isError,
    error,
  };
};
